import React, { useState } from 'react'
import { Box, Backdrop, Button, FormControl, FormHelperText, IconButton, InputAdornment, TextField } from '../../imports/muiImport';


import { Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { isValidPasswordChar, loginUser, userLoginValidation } from '../../mobile/mobileComponents/mobileUserAccountLogin/userAccoountHook';
import { actionNotifier } from '../../components/tostify';
import { validateOtp } from '../../apiCalls/urls/urlFunction';
import ErrorMsg from '../../components/errorMsg/ErrorMsg';
import BasicBtn from '../../components/button/BasicBtn';


const Login = ({ setOTPForm, setIsUserAuthentic }) => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);

  // ✅ Error message for alert
  const [errorAlert, setErrorAlert] = useState({
    open: false,
    message: '',
  });

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (e) => e.preventDefault();

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    setPhone(value);

    if (value.length !== 10) {
      setErrors((prev) => ({ ...prev, phone: 'Phone number must be exactly 10 digits!' }));
    } else {
      setErrors((prev) => ({ ...prev, phone: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setErrorAlert({ open: false, message: '' });

    const validation = userLoginValidation(phone, password);
    if (!validation?.success) {
      setErrors({
        phone: validation?.errors?.phone || '',
        password: validation?.errors?.password || '',
      });

      // ✅ Show alert error
      setErrorAlert({
        open: true,
        message: validation.message,
      });

      setLoginLoading(false);
      return;
    }

    setErrors({});

    try {
      const loginRes = await loginUser(validation.data.mobile, validation.data.password);

      if (!loginRes?.status) {
        setErrorAlert({
          open: true,
          message: "Invalid phone number or password",
        });
        setPhone('');
        setPassword('');
        setIsUserAuthentic({ mobile: null, status: false });
        return;
      }

      // const otpRes = await validateOtp(loginRes.mobile);
      // if (!otpRes?.status) {
      //   setErrorAlert({
      //     open: true,
      //     message: otpRes?.message || "Failed to send OTP",
      //   });
      //   return;
      // }

      // ✅ Success path
      actionNotifier.success(loginRes?.message, { position: "top-left", autoClose: 3000 });
      setOTPForm(true);
      setIsUserAuthentic({
        mobile: validation.data.mobile,
        status: true,
        isLoginForm: true
      });

    } catch (err) {
      console.error(err);
      setErrorAlert({
        open: true,
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setLoginLoading(false);
    }
  };

  const validateUserPassword = (e) => {
    const { value } = e.target;
    const lastChar = value.slice(-1);
    const isValidPassword = isValidPasswordChar(lastChar);

    if (isValidPassword || value === '') {
      setPassword(value);
    }
  }

  return (
    <Box component="div">
      <ErrorMsg
        open={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ ...errorAlert, open: false })}
        height={1}
      />

      <FormControl component="form" method="post" onSubmit={handleSubmit} fullWidth>
        <TextField
          fullWidth
          label="Phone Number"
          variant="outlined"
          value={phone}
          type="tel"
          onChange={handlePhoneChange}
          error={!!errors.phone}
          helperText={errors.phone}
          required
          margin="normal"
          InputProps={{
            inputProps: { maxLength: 10 },
          }}
          sx={{ backgroundColor: "white.main", border: 0 }}
        />

        <TextField
          fullWidth
          label="Password"
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={validateUserPassword}
          error={!!errors.password}
          helperText={errors.password}
          required
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ backgroundColor: "white.main", border: 0 }}
        />

        <FormControlLabel
          control={<Checkbox name="termsAccepted" checked={true} color="secondary" />}
          label="I hereby authorise to send notifications via SMS, Email, RCS and others as per Terms of Service | Privacy Policy * "
        />

        <BasicBtn
          type="submit"
          name="Sign in"
          color="secondary"
          smColor="primary"
          sx={{ mt: 3 }}
        />

        {Object.values(errors).some(Boolean) && (
          <FormHelperText error sx={{ mt: "4px", textAlign: 'left' }}>
            Please correct the errors above.
          </FormHelperText>
        )}
      </FormControl>

      <Backdrop sx={{ color: '#fff', zIndex: 999 }} open={loginLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Login;
